export default __webpack_public_path__ + "static/media/12-imusica.e209ed2a.png";